import { cn } from '@/lib/utils';

export default function H6({ children, className }: { children: string; className?: string }) {
    return <h6 className={cn('text-h6 font-medium', className)}>{children}</h6>;
}
